import React from "react";
import { useRef } from "react";
import {
    Container,
    Typography,
    Box,
    Button,
    Tabs,
    Tab,
    FormControl,
    Autocomplete,
    TextField
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import moment from 'moment';
import './PaymentSummary.css';
import { sortByString } from '../../utils/sortByString';
import { formatMoney } from '../../utils/moneyFormat';
import EstimateForm from "./EstimateForm";
import dayjs from 'dayjs';
import { useCompanyMessages } from '../../hooks/useMessages';
import { useCompanyInvoices } from '../../hooks/useInvoices';
import { EMPTY_GUID, NA_CUSTOMER_OPTION, customerAutocompleteOptions, isCustomerOptionEqual } from '../../query/queryConfig';

const PaymentSummary = ({handleCloseEstimate, item, dispatchSettings}) => {

    /// This page is to create an Invoice, is somewhat complex handle with care ///
    const fileReport = useSelector((state) => state.FileReducer.file);
    const userCompany = useSelector((state) => state.CompanyReducer.userCompanies);
    const companyId = userCompany[0]?.id;
    const { data: allCompanyMessages = [] } = useCompanyMessages({
        companyId,
        enabled: Boolean(companyId),
    });

    const [invoiceOptions, setInvoiceOptions] = React.useState([]);
    const [invoiceTaxOptions, setInvoiceTaxOptions] = React.useState([]);
    const [totalInvoiceSum, setTotalInvoiceSum] = React.useState(0);
    const [invoiceAfterTaxSum, setInvoiceAfterTaxSum] = React.useState(0);
    const [pointTypeTotal, setPointTypeTotal] = React.useState(0);
    const [results, setResults] = React.useState(fileReport.file);
    const [summary, setSummary] = React.useState(fileReport.summary);
    const [invoiceNum, setInvoiceNum] = React.useState(0);
    const [value, setValue] = React.useState(0);
    const [invoiceDate, setInvoiceDate] = React.useState(moment().format("MM/DD/YYYY"));
    const [jobName, setJobName] = React.useState("");

    const dispatch = useDispatch();

    let totalInvoice = 0;
    let taxTotal = 0;

    /// This sets the dropdown to select a customer for a plan in invoicing ///
    const allCustomers = allCompanyMessages;

    const customers = [];
    allCustomers?.forEach(customerPusher);

    function customerPusher(allCustomers) {
        if (allCustomers.requestStatus === 1 || allCustomers.requestStatus === 2) {
            customers.push({
                id: allCustomers.id,
                companyId: allCustomers.companyId,
                created: allCustomers.created,
                deleted: allCustomers.deleted,
                message: allCustomers.message,
                requestStatus: allCustomers.requestStatus,
                userId: allCustomers.userId,
                userEmail: allCustomers.userEmail,
                customerName: allCustomers.customerName,
                companyContact: allCustomers.companyContact,
                companyStatus: allCustomers.companyStatus,
                userCompanyId: allCustomers.userCompanyId
            })
        }
    };

    /// To Remove a row from the invoice ///
    function recalculateTotals() {
        taxTotal = 0;
        totalInvoice = 0;
        invoiceOptions?.map((option) => totalInvoice += option.rate * option.quantity);
        invoiceTaxOptions?.map(x => taxTotal += x.rate * totalInvoice);

        setTotalInvoiceSum(totalInvoice)
        setInvoiceAfterTaxSum(formatMoney(taxTotal + totalInvoice));
    };

    /// This sets the dropdown to select a customer for a plan in invoicing ///
    const [ selectedCustomer, setSelectedCustomer] = React.useState(NA_CUSTOMER_OPTION);

    let allCustomersArray = sortByString(allCustomers ?? [], 'companyContact');

    const defaultProps = {
        options: customerAutocompleteOptions(allCustomersArray),
        getOptionLabel: (option) => option.companyContact ?? '',
        isOptionEqualToValue: isCustomerOptionEqual,
    };

    function initializeInvoice(item) {
        let data;

        if(item?.invoiceValues != null){
            data = JSON.parse(item?.invoiceValues);
        }

        setInvoiceDate(data?.date);
        setInvoiceOptions(data?.items);
        setInvoiceTaxOptions(data?.taxes);
        setInvoiceNum(data?.estimateNumber);
        setJobName(item?.invoiceJobName);

        invoiceTaxOptions.map((taxOption) => taxTotal += taxOption.total);

        if (item.customerId != EMPTY_GUID){
            for (let i = 0; i < customers.length; i++){
                if (item.customerId == customers[i].userCompanyId){
                    setSelectedCustomer(customers[i]);
                }
            }
        }
    };

    function clearNclose() {
        handleCloseEstimate();
    };

    const startDateInitialState = dayjs().subtract(1, "years").startOf('day');
    const endDateInitialState = dayjs().endOf('day');
    const [exportStartDate, setExportStartDate] = React.useState(dayjs(startDateInitialState).format());
    const [exportEndDate, setExportEndDate] = React.useState(dayjs(endDateInitialState).format());

    const { data: companyInvoices = {} } = useCompanyInvoices({
        companyId,
        customerId: selectedCustomer?.userCompanyId,
        startDate: exportStartDate,
        endDate: exportEndDate,
        page: 0,
        pageSize: 50,
        enabled: Boolean(
            companyId
            && selectedCustomer?.userCompanyId
            && selectedCustomer.userCompanyId !== EMPTY_GUID
        ),
    });

    React.useEffect(() => {
        if(item != null){
            initializeInvoice(item);
        }
    },[]);

    React.useEffect(() => {
        recalculateTotals();
    },[invoiceOptions, invoiceTaxOptions]);

    React.useEffect(() => {
        if(!item){
            if(selectedCustomer.userCompanyId == EMPTY_GUID){
                setInvoiceNum(0);
            } else {
                setInvoiceNum(companyInvoices.foundTotalInvoiceCount + 1);
            };
        }
    },[companyInvoices]);

    // const { toPDF, targetRef } = usePDF({ filename: `${estimateObj?.companyContact?.replace(' ', '_')}-${estimateObj?.name?.split('.')[0]}.pdf`, method:'build' });

    return (
        <div style={{maxWidth: '100%', height:'100%' }}>
            <div className='estimatePage' maxWidth="sm" style={{display: 'flex', flexDirection: 'column', height:'inherit' }}>
            <Box sx={{ width: '95%' }}>
                <Button className="closeButton" onClick={()=> clearNclose()} style={{ fontSize: 24, fontWeight: 600, margin: 0, padding: 0}} >X</Button>
                        <Container
                            // ref={targetRef}
                        >
                            <Typography variant="h4" align="center">
                                Estimate Builder
                            </Typography>
                            <Typography align="center"><p>Fill out information here before presenting the estimate to a customer.</p></Typography>
                            <p style={{ display: "flex", justifyContent: 'right', width: "100%" }}>
                                <span style={{ marginRight: 50 }}>Date: {invoiceDate}</span>
                                <span># {invoiceNum}</span>
                            </p>
                            <div style={{ display: 'flex'}}>
                                <div style={{ flex: 1, margin: 2 }}>
                                    <div style={{ flex: 1, margin: 2 }}>
                                        <div style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', padding: 10 }}>
                                            <h4 style={{ display: "flex", justifyContent: 'left' }}>From Processor:</h4>
                                            <span style={{ display: "flex", justifyContent: "space-between", width: "100%", margin: 5 }}><span>{userCompany[0]?.name}</span></span>
                                            <span style={{ display: "flex", justifyContent: "space-between", width: "100%", margin: 5 }}><span>{userCompany[0]?.street}</span></span>
                                            <span style={{ display: "flex", justifyContent: "space-between", width: "100%", margin: 5 }}><span>{userCompany[0]?.city}, {userCompany[0]?.state} {userCompany[0]?.zip}</span></span>
                                            <span style={{ display: "flex", justifyContent: "space-between", width: "100%", margin: 5 }}><span>{userCompany[0]?.email}</span></span>
                                            <span style={{ display: "flex", justifyContent: "space-between", width: "100%", margin: 5 }}><span>{userCompany[0]?.phoneNumber}</span></span>
                                        </div>
                                    </div>
                                </div>
                                <div style={{ flex: 1, margin: 2 }}>
                                </div>
                                <div style={{ flex: 1, margin: 2 }}>
                                </div>
                                <div style={{ flex: 1, margin: 2 }}>
                                    <div style={{ flex: 1, margin: 2 }}>
                                        <div style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', padding: 10 }}>
                                            <h4 style={{ display: "flex", justifyContent: 'left' }}>To Customer:</h4>
                                            <span style={{ display: "flex", justifyContent: "space-between", width: "100%", margin: 5 }}><span>Company: {selectedCustomer?.companyContact}</span></span>
                                            <span style={{ display: "flex", justifyContent: "space-between", width: "100%", margin: 5 }}><span>Email: {selectedCustomer?.userEmail}</span></span>
                                            <br />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div style={{ flex: 1, margin: 10 , display:'flex', flexDirection:"row"}}>
                                <div style={{width:'50%', margin:'5px'}}>
                                    <h4>Job Name</h4>
                                    <p>Set a Job/Project name for this Estimate.</p>
                                    <br/>
                                    <FormControl fullWidth>
                                        <TextField value={jobName} onChange={(event) => {setJobName(event.target.value)}}></TextField>
                                    </FormControl>
                                </div>
                                {(item == null) &&
                                    <div style={{width:"50%", margin:'5px'}}>
                                        <form style={{}}>
                                            <h4>Customer Select</h4>
                                            <p>Select customer to set any applicable pricing options and to generate customer estimate upon acceptance of this estimate.</p>
                                            <FormControl fullWidth>
                                                <Autocomplete
                                                    disablePortal
                                                    value={selectedCustomer}
                                                    {...defaultProps}
                                                    renderInput={(params) =>
                                                        <TextField
                                                            {...params}
                                                        />}
                                                    onChange={(event,newValue) => {
                                                        swal({
                                                            title: "CHANGE CUSTOMER",
                                                            text: `Warning, changing customer can cause missmatched plans and or clearing of some filled in information if you have already started filling out the estimate, do you want to proceed?
                                                             You may want to consider clearing out any currently assigned information to prevent mixing up customer details.`,
                                                            icon: "warning",
                                                            buttons: true,
                                                            dangerMode: false,
                                                        })
                                                        .then((willUpdate) => {
                                                            if (willUpdate) {
                                                                if(newValue == null){
                                                                    setSelectedCustomer(NA_CUSTOMER_OPTION);
                                                                    setInvoiceNum(0);
                                                                }else{
                                                                    setSelectedCustomer(newValue);
                                                                }
                                                        } else {
                                                            swal({
                                                                title: `Customer Not Changed.`,
                                                                position: 'center'
                                                            });
                                                        }})
                                                    }}
                                                />
                                            </FormControl>
                                        </form>
                                    </div>
                                }
                            </div>
                            <br/>
                            <Typography variant="body1">
                                <b>Estimate</b>
                            </Typography>
                            <br />
                    <br/>
                    <EstimateForm
                        item={item}
                        handleCloseEstimate={handleCloseEstimate}
                        jobName={jobName}
                        selectedCustomer={selectedCustomer}
                        dispatchSettings={dispatchSettings}
                        invoiceNum={invoiceNum}
                    />
                    <br/>
                    <br/>
                    <br/>
                </Container>
            </Box>
        </div>
        </div>
    )
};

export default PaymentSummary;